import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Cancellation from './Cancellation';

import { AppState } from '../../../../store';
import { cancelDispensation as cancel } from '../../../../store/prescription/actions';

import { PrescriptionItemInterface } from '../../../../interfaces/prescription';
import { PermissionsInterface } from '../../../../interfaces/drugstore';

interface StateProps {
  token: string;
  itemsProps: PrescriptionItemInterface[];
  mustUpdateHistory: boolean;
  permissions: PermissionsInterface;
}

interface DispatchProps {
  cancelDispensation: Function;
}

type Props = StateProps & DispatchProps;

const CancellationContainer: React.FC<Props> = ({
  token,
  itemsProps,
  mustUpdateHistory,
  permissions,
  cancelDispensation,
}: Props) => {
  const [loadingItem, isLoadingItem] = useState<number | boolean>(false);
  const [items, setItems] = useState<PrescriptionItemInterface[]>(itemsProps);

  const filterItems = (itemsList: PrescriptionItemInterface[]): PrescriptionItemInterface[] => {
    return itemsList.filter((item: PrescriptionItemInterface) => item.dispensation.data.length);
  };

  const handleCancel = (id: number): void => {
    isLoadingItem(id);

    cancelDispensation(id, token).then(() => isLoadingItem(false));
  };

  useEffect(() => {
    if (!mustUpdateHistory) {
      return;
    }

    setItems(filterItems(itemsProps));
  }, [itemsProps, mustUpdateHistory]);

  return (
    <Cancellation items={items} cancelDispensation={handleCancel} loadingItem={loadingItem} permissions={permissions} />
  );
};

const mapStateToProps = ({ prescription, permissions }: AppState): StateProps => ({
  token: prescription.prescription.token,
  itemsProps: prescription.prescription.items,
  mustUpdateHistory: prescription.mustUpdateHistory,
  permissions,
});

const mapDispatchToProps = {
  cancelDispensation: cancel,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancellationContainer);
